import { IS_LOADED_STATE } from '@/constants';
import { selectorWithUniqueKey } from '@/utils';

import { useAuthState } from './auth-state';
import { useFeatureToggleState } from './feature-toggle-state';
import { useOnboardingState } from './onboarding-state';

export const useIsLoadedState = selectorWithUniqueKey({
  key: IS_LOADED_STATE,
  get: ({ get }): boolean => {
    const authState = get(useAuthState);
    const featureToggleState = get(useFeatureToggleState);
    const onnboardingState = get(useOnboardingState);

    return authState.loaded && featureToggleState.isLoaded && onnboardingState.loaded;
  },
});
